module.exports = __webpack_public_path__ + "img/coconut.6b4e919c.svg";